document.addEventListener('DOMContentLoaded', function() {
  var detailsElement = document.querySelector('.accordion');
  if (detailsElement) {
    detailsElement.addEventListener('toggle', function(event) {
      if (detailsElement.open) {
        detailsElement.setAttribute('aria-expanded', 'true');
      } else {
        detailsElement.setAttribute('aria-expanded', 'false');
      }
    });
  } else {
    console.error('Accordion element not found.');
  }
});